const FONT_SIZE_CONFIG = {
  S: '2cqh',
  M: '2.5cqh',
  L: '3cqh',
  XL: '4cqh'
} as const;

export type FontSizePreset = keyof typeof FONT_SIZE_CONFIG;

export const FONT_SIZE_PRESETS = Object.keys(FONT_SIZE_CONFIG) as FontSizePreset[];

export const getFontSizeForPreset = (preset: FontSizePreset): string => FONT_SIZE_CONFIG[preset];

export const isFontSizePreset = (value: string | undefined): value is FontSizePreset =>
  !!value && value in FONT_SIZE_CONFIG;

export function cssToPreset(cssValue: string | undefined, defaultPreset: FontSizePreset = 'L'): FontSizePreset {
  if (!cssValue) {
    return defaultPreset;
  }

  return FONT_SIZE_PRESETS.find(key => FONT_SIZE_CONFIG[key] === cssValue) ?? defaultPreset;
}

export const DEFAULT_NAME_FONT_SIZE_PRESET: FontSizePreset = 'M';
export const DEFAULT_TITLE_FONT_SIZE_PRESET: FontSizePreset = 'S';

export const LEGACY_NAME_FONT_SIZE = 'max(2.5cqi, 12px)';
export const LEGACY_TITLE_FONT_SIZE = 'max(2cqi, 10px)';
